import React, { useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { centeredNotification, emptyFunction } from '../../../utils/utility';
import { IDEAL_TIMEOUT_ERR } from '../../constants/commonConstants';

const IdealTimeout = (): any => {
  const time = useRef<any>(null);
  const TIMEOUT_TIME = parseInt(process.env.REACT_APP_IDEAL_TIMEOUT || '1800000', 10);
  const history = useHistory();

  const updateListeners = (assignedFn: any = emptyFunction): void => {
    document.onmousemove = assignedFn;
    document.onkeydown = assignedFn;
    document.onmousedown = assignedFn;
    document.ontouchstart = assignedFn;
    document.ontouchmove = assignedFn;
    document.onclick = assignedFn;

    if (assignedFn === emptyFunction) {
      document.removeEventListener('scroll', resetTimer, true);
    } else {
      document.addEventListener('scroll', resetTimer, true);
    }
  };

  useEffect((): any => {
    resetTimer();
    updateListeners(resetTimer);

    return (): any => {
      if (time.current) {
        clearTimeout(time.current);
      }
      updateListeners(emptyFunction);
    };
  }, []);

  const resetTimer = (): any => {
    if (time.current) {
      clearTimeout(time.current);
    }

    time.current = setTimeout((): any => {
      history.push('/logout');
      centeredNotification(IDEAL_TIMEOUT_ERR, 'info', null, 0);
    }, TIMEOUT_TIME);
  };

  return (
    <></>
  );
};

export default IdealTimeout;
